'use strict';
(function () {
  var _controller = 'storeTracking.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'flyer.resource', 'hq.socket', 'order.resource', 'product.resource', 'storeUtils', '$interval', 'appRate.modal', '$timeout'];
  function controller($scope, flyerResource, hqSocket, orderResource, productResource, storeUtils, $interval, appRateModal, $timeout) {
    /// METHODS
    $scope.mainResource = flyerResource;
    $scope.homeContents = null;
    $scope.toStore = toStore;
    $scope.totalPrice = totalPrice;


    /// VARS
    $scope.order = appNavigator.topPage.data && appNavigator.topPage.data.order;
    $scope.orderHasVoucher = !!$scope.order.products.find(function (f) { return f.properties && f.properties.cardTemplate });
    $scope.state = null;
    $scope.rejectedReason;
    $scope.allProducts = productResource.query({ _controller: _controller, router: $scope.$root.defaultRouter, _select: 'properties.name masterProduct' })
    var refreshTS;
    var minRefreshInterval = 1000 * 60 * 3;

    // WATCHERS
    $scope.$on('$destroy', onDestroy);
    hqSocket.on('ORDER_UPSERT', onUpsertOrder)
    hqSocket.on('connect', refresh)

    /// INIT
    refresh();

    // Luego de reiteredas quejas de clientes de que el tracking no actualiza, se vio forzado a agregar este interval
    // Hubo varios casos de clientes que esperaron media hora y llamaron enojados al local para enterarse de que había sido aprobado apenas pidieron
    // Este socket hace un requerimiento que filtra en base de datos por _id, lo cual es muy rápido y eficiente
    var refreshInterval = $interval(function(){if((Date.now() - refreshTS) > minRefreshInterval) refresh()}, 1000 * 10); 

    // TODO: Cargar el estado actual

    init();

    if ($scope.order.scheduleData) {
      if ($scope.order.scheduleData.from) {
        $scope.order.scheduleData.fromToday = moment($scope.order.scheduleData.from).format('YYYYMMDD') === moment().format('YYYYMMDD')
        $scope.order.scheduleData.fromTomorrow = moment($scope.order.scheduleData.from).format('YYYYMMDD') === moment().add('days', 1).format('YYYYMMDD')
      }
      if ($scope.order.scheduleData.to) {
        $scope.order.scheduleData.toToday = moment($scope.order.scheduleData.to).format('YYYYMMDD') === moment().format('YYYYMMDD')
        $scope.order.scheduleData.toTomorrow = moment($scope.order.scheduleData.to).format('YYYYMMDD') === moment().add('days', 1).format('YYYYMMDD')
      }
    }

    /////////////////////
    function onUpsertOrder(data) {
      if (data !== $scope.order._id) return;
      refresh();
    }

    function refresh() {
      refreshTS = Date.now();
      orderResource.get({ _id: $scope.order._id, _select: ['checkoutMethod', 'queue.status', 'queue.estimatedDelay', 'scheduleData.*', 'queue.estimatedDate', 'queue.ts', 'delivery.status', 'delivery.estimatedDelay', 'delivery.ts', 'rejected', 'rejectedReason', 'serial'], _controller: _controller }, function (data) {
        $scope.state = null;
        $scope.checkoutMethod = data.checkoutMethod;
        if (data.delivery) {
          if (!$scope.order.delivery) $scope.order.delivery = {}
          $scope.order.delivery.estimatedDelay = data.delivery.estimatedDelay;
        }
        if (data.rejected) {
          $scope.state = 'REJECTED';
          $scope.rejectedReason = data.rejectedReason;
        } else {
          if (!data.queue || !data.queue.status || data.queue.status === 'CALLED' && data.delivery && data.delivery.status) {
            if (data.delivery && data.delivery.status) $scope.state = data.delivery.status || 'CLOSED';
          } else {
            $scope.state = data.queue.status || 'CLOSED';
            $scope.order.queue.estimatedDelay = data.queue.estimatedDelay;
            $scope.order.queue.estimatedDate = data.queue.estimatedDate;
          }
        }
        if (!$scope.state) $scope.state = 'CLOSED'
      })
    }

    function init() {
      $timeout(function(){appRateModal.open('storeTracking')}, 1000);
      //- Obtengo configuracion del Router
      $scope.router = $scope.$root.routers.filter(function (f) { return f._id === $scope.$root.defaultRouter })[0];
      if (!$scope.router) return
      //- Obtengo Alertas TRAKING
      $scope.trackingAlerts = storeUtils.filterBuyMessage($scope.router.showBuyMessage, 'TRACKING').filter(function (f) { return storeUtils.doesMatch($scope.order, f); })
    }

    function toStore() {
      appNavigator.resetToPage('store/storeProductSelection/storeProductSelection.jade')
    }

    function totalPrice() { return $scope.order.totalPrice; }

    function onDestroy() {
      hqSocket.removeListener('ORDER_UPSERT', onUpsertOrder)
      hqSocket.removeListener('connect', refresh)
      $scope.$root.abortRequests(_controller);
      $interval.cancel(refreshInterval)
    }

    //// FIN CONTROLLER
  }
})();
